import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class PromotionAPI {

    URI_V1 = "/v1/promotions"

    create = async (data: any) => {
        return await apiService.post(`${this.URI_V1}`, data);
    };

    toggleActive = async (promotionId: any, newStatus: any) => {
        return await apiService.put(`${this.URI_V1}/update-status?promotionId=${promotionId}&newStatus=${newStatus}`, null);
    };

    deletePromotion = async (promotionId: any) => {
        return await apiService.delete(`${this.URI_V1}/${promotionId}`);
    };

    // PromotionAPI.js
    findAllPromotions = async (page = 0, limit = 12, name = "") => {
        const companyId = companyAPI.getCompanyManagment().id;

        const params = new URLSearchParams();
        params.append("companyId", companyId);
        params.append("page", page.toString());
        params.append("limit", limit.toString());

        const q = String(name || "").trim();
        if (q) params.append("name", q);

        return await apiService.get(`${this.URI_V1}?${params.toString()}`);
    };


    getPromotionById = async (promotionId: any) => {
        return await apiService.get(`${this.URI_V1}/${promotionId}`);
    }

    update = async (promotionId: any, payload: any) => {
        return await apiService.put(`${this.URI_V1}/${promotionId}`, payload);
    };

}
